import { getAmpConfigFlags } from 'src/services/amp-config.service';
import authService from 'src/services/api/auth.service';
import { loggerService } from 'src/services/logger.service';
import { useGetTeacherAssignmentsQuery } from 'src/store/api/assignment';
import {
  useActiveMSAssignmentsSubject,
  useCurrentAppViewSelector,
  useHasViewUpdatedSelector,
  useSelectedClassSelector,
} from 'src/store/features';

import { useIsMiddleSchoolView } from '../use-is-middle-school-view';

// TODO: Remove after RFS.
export const useMSTeacherAssignments = () => {
  const selectedClass = useSelectedClassSelector();
  const isMiddleSchoolView = useIsMiddleSchoolView();
  const currentAppView = useCurrentAppViewSelector();

  const activeMSAssignmentsSubject = useActiveMSAssignmentsSubject();

  const isStudent = authService.isStudent();

  const hasViewUpdated = useHasViewUpdatedSelector();

  const isUpdatedMSViewEnabled = getAmpConfigFlags().isUpdatedMSViewEnabled;

  const shouldSkipQuery =
    isStudent ||
    // now query is allowed for class-less users, so only check for undefined
    selectedClass === undefined ||
    currentAppView === null ||
    !isMiddleSchoolView ||
    !hasViewUpdated ||
    isUpdatedMSViewEnabled;

  const classBks = selectedClass?.length
    ? selectedClass.map((cl) => cl.sourcedId)
    : [];
  const groupBks: string[] = [];

  const queryResult = useGetTeacherAssignmentsQuery(
    {
      classBks,
      groupBks,
      domain: activeMSAssignmentsSubject,
    },
    { skip: shouldSkipQuery },
  );

  if (queryResult.error) {
    loggerService.logError(
      'Something went wrong during MS teacher assignments query',
      queryResult.error,
    );
  }

  return queryResult;
};
